










import Vue from "vue";
import {Component} from "vue-property-decorator";
import PopUp from './views/PopUp.vue'
window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  }, {
    passive: false  // 关闭被动监听
  });
  let lastTouchEnd = 0;
  document.addEventListener('touchend', function (event) {
    let now = (new Date()).getTime();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, false);
};
@Component({
  components: {PopUp}
})
export default class App extends Vue {
  transitionName = ''
  showQrcode = false

  created(){
    if(document.documentElement.clientWidth >500){
      this.showQrcode = true
    }
  }
}
